module.exports = {
  lange: {
    hversion: 'Versions',
    zsize: 'Size',
    updateTime: 'Update Time',
    Android: 'Android Download',
    Apple: 'Apple Download',
    title: 'Scan the qrcode to download',
    QRcode: 'Scan QR code to download',
    mobile: 'Or use your mobile browser to open the URL:',
    facilityAndroid: 'For Android',
    facilityiPhone: 'For Apple',
    ilucode: 'Code distribution',
    disclaimer: 'Disclaimer',
    report: 'Report',
    install: 'In the installation... Please check the desktop!',
    explain: 'As a third-party private beta distribution platform, we have been committed to cracking down on illegal applications and protecting the rights and interests of users.Thank you very much for your report. We will arrange a special person to deal with your report as soon as possible.Thank you for your support.',
    reptype: 'Please choose a topic you want to report:',
    pirate: 'Pirate',
    yellow: 'Porn',
    cheat: "Scam",
    other: 'Other',
    Reasons: 'Reason for report:',
    replenish: 'Please add the reason for the report...',
    email: 'Email',
    write: 'Please fill in your email address',
    affirm: 'Report',
    back: 'Back',
    phone: 'Telephone Number：',
    mobiles: 'Please enter your mobile phone number',
    one: 'Please select the type of report',
    two: 'Please add the reason.',
    three: 'Please fill in the email',
    four: 'Please enter the correct email address',
    five: 'Please fill in your mobile phone number',
    six: 'Please input the correct mobile phone number',
    freeDown: "Free Download",
    introduction: 'Introduction',
    ZeroScore: 'Zero score',
    Rating: 'Rating and Comments',
    age: 'age',
    points: 'Out of 5 points',
    newFunction: 'New Function',
    message: 'Message',
    nstallation: 'Nstallation Package Size',
    compatibility: 'compatibility',
    language: 'Language',
    grading: 'Age Grading',
    price: 'price',
    compatibilityInfo: 'Requires iOS or later.Compatible with iPhone, iPad and iPodtouch.',
    limit: 'Limit to more than 4 years',
    free: 'free',
    tutorial: 'Install the tutorial',
    languageInfo: 'English',
    introduce: 'Description',
    remark: 'Remark',
    contact: 'Contact',
    password: 'Please enter the password',
    enter: 'Enter',
    phonecode: 'code',
    tsphonecode: 'Verification code',
    inphonecode: 'Image verification code',
    errphonecode: 'The image verification code is incorrect',
    errcode: 'Password mistake',
    download: 'Download',
    downipa: 'Untrusted enterprise developer',
    downsuper: 'Installation tutorial',
    instaling: 'Installing, please check on your home screen',
    iosDescribe: 'Trust developer',
    superDescribe: 'Installing, please check on your home screen',
    iOSAndroid: 'For iOS & Android',
  },


}



// WEBPACK FOOTER //
// ./src/i18n/en.js